/**
 * 開閉式フィルターの先頭の並び (UI 辞書 toolbar-collapsible.md、2026-10-23)。
 * カードにも閉じた要約にも、エリアがあれば左上の先頭、期間関連があればその直後。
 * 期間関連が複数あるときは、渡された相対順のまままとめる。ほかの項目はその後ろに、渡された順で続ける。
 * 期間の部品がカードの外 (`leading` に置いた表示日) にある画面は、カードの先頭はエリア。
 */
const PERIOD_KEYS = new Set([
  'rangeType',
  'period',
  'planPeriod',
  'section',
  'date',
  'targetDate',
  'deliveryDate',
  'dayRange',
  'weekStart',
  'monthStart',
  'fiscalYear',
])

const rankOf = (key: string): number => {
  if (key === 'area') return 0
  if (PERIOD_KEYS.has(key)) return 1
  return 2
}

/** エリア → 期間関連 → 残り。同じ区分の中の順は保つ。 */
export const pinAreaAndPeriodFirst = <T extends { key: string }>(
  items: readonly T[],
): T[] =>
  items
    .map((item, index) => ({ item, index, rank: rankOf(item.key) }))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .map(({ item }) => item)
